import { useState } from "react";

const useExpandedList = () => {
  const [expandedList, setExpandedList] = useState([]);

  const addToExpandedList = (func) => {
    setExpandedList((prevList) => [...prevList, func]);
  };

  const handleExpandAll = () => {
    expandedList.forEach((expandedObj) => {
      expandedObj(true);
    });
  };

  const handleCollapseAll = () => {
    expandedList.forEach((expandedObj) => {
      expandedObj(false);
    });
  };
  return {
    addToExpandedList,
    handleExpandAll,
    handleCollapseAll,
  };
};

export default useExpandedList;
